module.exports = __webpack_public_path__ + "img/qminkeige.ef7c6eb8.webp";